import type { RankRow } from '@/types/content';
import { formatRankChange } from '@/utils/content';

export default function RankTable({ rows }: { rows: RankRow[] }) {
  return (
    <div className="overflow-x-auto rounded-lg border border-background-200">
      <table className="w-full min-w-[560px] text-sm">
        <caption className="sr-only">选手排名变化表</caption>
        <thead>
          <tr className="bg-background-100 text-foreground-600">
            <th className="text-left font-semibold px-4 py-3">排名</th>
            <th className="text-left font-semibold px-4 py-3">选手</th>
            <th className="text-left font-semibold px-4 py-3">战队</th>
            <th className="text-right font-semibold px-4 py-3">排名变化</th>
            <th className="text-right font-semibold px-4 py-3">表现评分</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={`${row.rank}-${row.player}`} className="border-t border-background-200">
              <td className="px-4 py-3">
                <span
                  className={`inline-flex w-7 h-7 items-center justify-center rounded-md text-xs font-bold ${
                    row.rank === 1
                      ? 'bg-accent-500 text-primary-950'
                      : 'bg-background-100 text-foreground-700'
                  }`}
                >
                  {row.rank}
                </span>
              </td>
              <td className="px-4 py-3 font-medium text-foreground-900 whitespace-nowrap">
                {row.player}
              </td>
              <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{row.team}</td>
              <td
                className={`px-4 py-3 text-right font-bold whitespace-nowrap ${
                  row.change > 0
                    ? 'text-primary-700'
                    : row.change < 0
                      ? 'text-accent-700'
                      : 'text-foreground-500'
                }`}
              >
                {formatRankChange(row.change)}
              </td>
              <td className="px-4 py-3 text-right font-semibold text-foreground-800">
                {row.score.toFixed(1)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}